import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-lodash-debounce'
import { FormFields } from '~/components/FormFields'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const CityField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control, setValue, getValues } = useFormContext()
  const { t } = useTranslation()
  const required = !disabled && Boolean(field.fieldRequired)

  const zipName = `${name}.value`
  const cityName = `${name}.value2`
  const [zipTouched, setZipTouched] = useState(false)
  const watchZip = useWatch({ control, name: zipName })
  const debounceZip = useDebounce(watchZip, 300)

  const { data: zipData, refetch: fetchZipData } = FarmersQuery.getZipDistrictState(debounceZip, zipTouched)

  useEffect(() => {
    if (zipTouched && String(debounceZip || '').length >= 4) {
      fetchZipData()
    }
  }, [debounceZip, zipTouched])

  useEffect(() => {
    if (!zipTouched || !zipData?.countryId) return

    const self = getValues(name)
    const allFields = (getValues('fields') as any[]) || []
    const findSibling = (slug: string) =>
      allFields.findIndex(f => f?.slug === slug && f?.category === self?.category && f?.farmerId === self?.farmerId)

    const countryIndex = findSibling('country')
    const cantonIndex = findSibling('canton')
    setValue(cityName, zipData.name)
    if (countryIndex >= 0) {
      setValue(`fields[${countryIndex}].value`, zipData.countryId)
    }
    if (cantonIndex >= 0) {
      setValue(`fields[${cantonIndex}].value`, Number(zipData.cantonId))
    }
  }, [zipData])

  return (
    <>
      <FormFields.Input
        label={<LabelWithInfo label={t('Zip')} info={field.info} required={required} />}
        placeholder={t('Enter zip')}
        control={control}
        disabled={disabled}
        onChange={() => setZipTouched(true)}
        rules={required ? {
          required: {
            value: true,
            message: t('Please enter Zip')
          }
        } : {}}
        name={zipName}
      />
      <FormFields.Input
        label={<LabelWithInfo label={field.label} info={field.info} required={required} />}
        placeholder={field.placeholder}
        control={control}
        disabled={disabled}
        rules={required ? {
          required: {
            value: true,
            message: t('Please enter City')
          }
        } : {}}
        name={cityName}
      />
    </>
  )
}

export default CityField
